export default "__VITE_ASSET__CO54M9Nd__"